import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: 'r0lzgugu',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'skAAUyL7XWU8oPxSlirDk4GNBaqFSNRqsMYdxWKqEk2IxttOxm6emsGwdCjMesvKHBd1n7qapFtosaPQJbgpUcNQBrHIi8YzCCaj8kjUZBa8obL7AahztfNaHQRbA5eIBZAwh26QGZM1aot90pCe8SWbonNWkqUtxIvJtBLrtCyCKU2Xi88S',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
